import React, { useState, useRef, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import PurpleButton from '../common/PurpleButton/PurpleButton';
import emailjs from '@emailjs/browser';
import 'react-phone-input-2/lib/style.css';
import './ContactForm.css';

const ContactForm = () => {
  const [phone, setPhone] = useState('');
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    address: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [pageInfo, setPageInfo] = useState('');
  const [showModal, setShowModal] = useState(false);
  const formRef = useRef();
  
  // const [budget, setBudget] = useState(20000);
  // const [captcha, setCaptcha] = useState('183961'); // 实际应用中应该动态生成

  // const handleBudgetChange = (e) => {
  //   const value = parseInt(e.target.value);
  //   setBudget(value);
  //   const progress = ((value - 20000) / (500000 - 20000)) * 100;
  //   e.target.style.setProperty('--range-progress', `${progress}%`);
  // };

  // useEffect(() => {
  //   const progress = ((budget - 20000) / (500000 - 20000)) * 100;
  //   const slider = document.querySelector('.range-slider');
  //   if (slider) {
  //     slider.style.setProperty('--range-progress', `${progress}%`);
  //   }
  // }, []);

  // const formatBudget = (value) => {
  //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };

  // 获取当前页面URL
  useEffect(() => {
    setPageInfo(window.location.href);
  }, []);
  
  // 处理输入变化
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 关闭成功弹窗
  const closeModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    
    // 将电话号码添加到隐藏字段
    if (formRef.current) {
      const phoneInput = formRef.current.querySelector('input[name="phone"]');
      if (phoneInput) {
        phoneInput.value = phone;
      }
      
      const pageInfoInput = formRef.current.querySelector('input[name="page_info"]');
      if (pageInfoInput) {
        pageInfoInput.value = pageInfo;
      }
    }
    
    emailjs.sendForm(
      'service_0qn969g',
      'template_fsnd7dq',
      formRef.current,
      'PcHzeyHQ7091mGvgC'
    )
    .then((response) => {
      console.log('邮件发送成功!', response.status, response.text);
      setSuccess(true);
      setShowModal(true);
      setLoading(false);
      // 重置表单
      setFormData({
        fullname: '',
        email: '',
        address: '',
        message: ''
      });
      setPhone('');
    })
    .catch((err) => {
      console.error('邮件发送失败:', err);
      setError('发送失败，请稍后再试');
      setLoading(false);
    });
  };

  return (
    <div className="contact-form">
      <h2>联系我们</h2>
      {error && <div className="error-message">{error}</div>}
      <form ref={formRef} onSubmit={handleSubmit}>
        {/* 隐藏字段用于存储电话号码和当前页面URL */}
        <input type="hidden" name="phone" />
        <input type="hidden" name="page_info" value={pageInfo} />
        
        <div className="form-row">
          <div className="form-group">
            <label>姓名<span className="required">*</span></label>
            <input 
              type="text" 
              name="fullname"
              value={formData.fullname}
              onChange={handleChange}
              placeholder="请输入您的姓名" 
              required 
            />
          </div>
          <div className="form-group">
            <label>邮箱<span className="required">*</span></label>
            <input 
              type="email" 
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="请输入您的邮箱" 
              required 
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>联系电话<span className="required">*</span></label>
            <PhoneInput
              country={'cn'}
              value={phone}
              onChange={setPhone}
              inputStyle={{ width: '100%', height: '40px' }}
              required
            />
          </div>
          <div className="form-group">
            <label>地址</label>
            <input 
              type="text" 
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="请输入您的地址" 
            />
          </div>
        </div>

        {/* <div className="form-group">
          <label>项目预算: ￥{formatBudget(budget)}</label>
          <input
            type="range"
            min="20000"
            max="500000"
            step="1000"
            value={budget}
            onChange={handleBudgetChange}
            className="range-slider"
            style={{padding:"0",height:"5px"}}
          />
          <div className="range-labels">
            <span>￥20,000</span>
            <span>￥500,000</span>
          </div>
        </div> */}

        <div className="form-group">
          <label>留言<span className="required">*</span></label>
          <textarea 
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="请输入您的留言" 
            rows="5" 
            required
          ></textarea>
        </div>

        {/* <div className="form-group captcha-group">
          <label>验证码<span className="required">*</span></label>
          <div className="captcha-container">
            <div className="captcha-image">{captcha}</div>
            <input type="text" placeholder="请输入验证码" />
            <button type="button" className="refresh-captcha">
              <i className="fas fa-sync-alt"></i>
            </button>
          </div>
        </div> */}

        <div className="submit-button-container">
          <PurpleButton 
            text={loading ? "发送中..." : "发送消息"} 
            type="submit"
            disabled={loading}
            className="contact-submit-button"
          />
        </div>
      </form>
      
      {/* 成功提交弹窗 */}
      {showModal && (
        <div className="success-modal-overlay">
          <div className="success-modal">
            <div className="success-modal-content">
              <h3>提交成功</h3>
              <p>消息已成功发送！我们会尽快与您联系。</p>
              <button onClick={closeModal} className="close-modal-btn">确定</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm; 